import { useMemo } from "react";
import auditAiIcon from '../assests/images/Icons/auditAi.svg';
import GetAppIcon from '@mui/icons-material/GetApp';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DrawIcon from '@mui/icons-material/Draw';
import DescriptionIcon from '@mui/icons-material/Description';
import FolderSpecialIcon from '@mui/icons-material/FolderSpecial';
import ReceiptIcon from '@mui/icons-material/Receipt';
import CancelIcon from '@mui/icons-material/Cancel';
import NoteIcon from '@mui/icons-material/Note';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import PrintIcon from '@mui/icons-material/Print';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Swal from 'sweetalert2';
import PartnerService from '../Services/partner.service';
import { MENU_ITEMS, MENU_CATEGORIES, isRestricted, isCategoryRestricted } from '../assests/Constants/menuRestrictionKeys.js';
import { PERMANENT_FILE_TITLE_NAME } from '../Utils/otherDocumentSections';

export function useMenuItems({
    t,
    client,
    userTypeContext,
    permissionsState,
    Constants,
    parsedOtherDocuments,
    parsedPermanentFiles,
    parsedCustomTitles = [],
    viewAccountCardsTable,
    viewDocumentDetails,
    viewPaymentAcceptanceDetails,
    viewJournalEntryDetails,
    viewAssets,
    viewProjects,
    viewReceivables,
    viewReceivablesAging,
    viewCashFlowForecast,
    viewForeignTravelReport,
    viewClientExpenseAssignmentReport,
    viewProfitAndLossDetails,
    viewProfittAndLoss6111,
    viewReport1214,
    viewReport1214B,
    viewReport1281,
    viewReport1362,
    viewAnnualReportQuestionnaire,
    viewLedgerReport,
    openReferenceSequenceModal,
    openReferencesModal,
    downloadWithholdingTaxReport,
    downloadPCNReport,
    downloadVATReport,
    openWithholdingTaxModel,
    openClientWithholdingTaxModel,
    handleClickOpen856,
    handleClickUnifrom,
    viewClientItems,
    viewTransactionDocuments,
    viewDocumentCreate,
    viewBankTransactions,
    viewCardMatching,
    viewBankPage,
    viewOtherDocumentDetails,
    viewHoldingItems,
    viewClarificationDocuments,
    viewInventoryItems,
    viewVehicleManagement,
    viewGarageWorkDiary,
    viewAudit,
    viewAccountCardDashboardBAccountCard,
    viewSignatureDocument,
    viewForms,
    viewAddClient,
    handleDownloadReceptionLog,
    // ICONS
    accountCardsDetailsIcon,
    incomesIcon,
    expensesIcon,
    paymentAcceptanceIcon,
    journalEntryIcon,
    assetIcon,
    projectIcon,
    sortCodeReportIcon,
    profitAndLossIcon,
    accountCardsTableIcon,
    referenceSequenceIcon,
    reportsIcon,
    reports1Icon,
    advancesReportIcon,
    pcnFileIcon,
    vatReportIcon,
    InvoiceItemsIcon,
    transactionDocumentsIcon,
    bankIcon,
    cardMatchingIcon,
    bankPageIcon,
    otherDocumentIcon,
    setShow856Modal,
    setShowUniformFileModal,
    onManageMonthlyStatus,
    openDateModal,
    isFromHamburgerMenu = false,
    holdingItemsIcon,
    auditIcon = auditAiIcon,
    hideStatusBadge = false,
    token = null,
    partners = [],
    subAccountantCaseRestrictions = []

}) {
    const restrictions = subAccountantCaseRestrictions || [];

    const filterByRestrictions = (items, categoryKey) => {
        if (isCategoryRestricted(restrictions, categoryKey)) return [];
        return items
            .filter((item) => !item.menuKey || !isRestricted(restrictions, item.menuKey))
            .map((item) => {
                const { menuKey, ...rest } = item;
                if (rest.subItems && Array.isArray(rest.subItems)) {
                    rest.subItems = rest.subItems
                        .filter((sub) => !sub.menuKey || !isRestricted(restrictions, sub.menuKey))
                        .map(({ menuKey: _k, ...s }) => s);
                }
                return rest;
            });
    };

    const accountingItemsRaw = useMemo(() => [
        { menuKey: MENU_ITEMS.Incomes, label: t('Incomes'), icon: incomesIcon, onClick: () => viewDocumentDetails("Incomes"), count: hideStatusBadge ? undefined : (client?.documentCounts?.incomes ?? 0), subItems: null },
        { menuKey: MENU_ITEMS.Expenses, label: t('Expenses'), icon: expensesIcon, onClick: () => viewDocumentDetails("Expenses"), count: hideStatusBadge ? undefined : (client?.documentCounts?.expenses ?? 0), subItems: null },
        { menuKey: MENU_ITEMS.PaymentAcceptances, label: t('PaymentAcceptance'), icon: paymentAcceptanceIcon, onClick: () => viewPaymentAcceptanceDetails("PaymentAcceptances"), count: hideStatusBadge ? undefined : (client?.documentCounts?.checks ?? 0), subItems: null },
        ...(userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium ? [{ menuKey: MENU_ITEMS.JournalEntries, label: t('JournalEntry'), icon: journalEntryIcon, onClick: () => viewJournalEntryDetails("JournalEntries"), count: hideStatusBadge ? undefined : (client?.documentCounts?.journalEntries ?? 0), subItems: null }] : []),
        ...(userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium ? [{ menuKey: MENU_ITEMS.Assets, label: t('Depreciation'), icon: assetIcon, onClick: () => viewAssets("Assets"), subItems: null }] : []),
        ...(userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium ? [{ menuKey: MENU_ITEMS.HoldingItems, label: t('HoldingItems'), icon: holdingItemsIcon, onClick: () => viewHoldingItems("HoldingItems"), subItems: null }] : []),
        { menuKey: MENU_ITEMS.PrintChecks, label: t('PrintChecks'), icon: () => <PrintIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewPaymentAcceptanceDetails("PaymentAcceptances", { openPrintChecksModal: true }), subItems: null },
        ...(userTypeContext?.toString() !== Constants.UserType.Client ? [{ menuKey: MENU_ITEMS.DocumentsRequiringClarification, label: t('DocumentsRequiringClarification'), icon: () => <HelpOutlineIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewClarificationDocuments("DocumentsRequiringClarification"), count: hideStatusBadge ? undefined : (client?.documentCounts?.clarificationDocuments ?? 0), subItems: null }] : []),
    ], [t, client, userTypeContext, permissionsState, Constants, hideStatusBadge, viewDocumentDetails, viewPaymentAcceptanceDetails, viewJournalEntryDetails, viewAssets, viewHoldingItems, viewClarificationDocuments, incomesIcon, expensesIcon, paymentAcceptanceIcon, journalEntryIcon, assetIcon, holdingItemsIcon]);
    const accountingItems = useMemo(() => filterByRestrictions(accountingItemsRaw, MENU_CATEGORIES.Accounting), [accountingItemsRaw, restrictions]);

    const settingsItemsRaw = useMemo(() => [
        {
            menuKey: MENU_ITEMS.AccountCardsTable,
            label: t('AccountCardsTable'),
            icon: accountCardsDetailsIcon,
            onClick: () => viewAccountCardsTable('AccountCardsTable'),
            subItems: null,
        },
        ...(client?.managesProject ? [{ menuKey: MENU_ITEMS.Projects, label: t('Projects'), icon: projectIcon, onClick: () => viewProjects("Projects"), subItems: null }] : []),
        {
            menuKey: MENU_ITEMS.TransactionDocuments,
            label: t('DocumentsSettings'),
            icon: transactionDocumentsIcon,
            onClick: () => viewTransactionDocuments('TransactionDocuments', false, {
                openDocumentSettingsDialog: true,
                breadcrumbs: ['Settings', 'DocumentsSettings'],
            }),
            subItems: null,
        },
        {
            menuKey: MENU_ITEMS.ReferenceSequence,
            label: t('References'),
            icon: referenceSequenceIcon,
            onClick: openReferencesModal,
            subItems: null,
        },
        ...(!permissionsState.CannotAddClient ? [{
            menuKey: MENU_ITEMS.EditClient,
            label: t('EditClient'),
            icon: () => <EditOutlinedIcon sx={{ color: '#304FFF', fontSize: 24 }} />,
            onClick: () => viewAddClient(true),
            subItems: null,
        }] : []),
        ...(onManageMonthlyStatus && (userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium) ? [{
            label: t('ManageMonthlyStatus'),
            icon: () => <CalendarMonthIcon sx={{ color: '#304FFF', fontSize: 24 }} />,
            onClick: onManageMonthlyStatus,
            subItems: null,
        }] : []),
    ], [t, client, permissionsState.CannotAddClient, permissionsState.Premium, userTypeContext, Constants, viewAccountCardsTable, viewProjects, viewTransactionDocuments, viewAddClient, openReferencesModal, onManageMonthlyStatus, accountCardsDetailsIcon, projectIcon, transactionDocumentsIcon, referenceSequenceIcon]);
    const settingsItems = useMemo(() => filterByRestrictions(settingsItemsRaw, MENU_CATEGORIES.Settings), [settingsItemsRaw, restrictions]);

    // Helper function to handle partner selection for advance report download
    const handleAdvanceReportWithPartnerSelection = async (onConfirm) => {
        // Check if client is a partnership
        if (!client?.isPartners) {
            // Not a partnership, proceed without partner selection
            onConfirm(null);
            return;
        }

        // Fetch partners if not already available
        let partnersList = partners;
        if (!partnersList || partnersList.length === 0) {
            if (!token || !client?.caseId) {
                // Can't fetch partners, proceed without selection
                onConfirm(null);
                return;
            }
            try {
                const response = await PartnerService.getPartnersByCaseId(client.caseId, token);
                if (response.ok) {
                    partnersList = await response.json();
                } else {
                    // Failed to fetch partners, proceed without selection
                    onConfirm(null);
                    return;
                }
            } catch (error) {
                console.error('Error fetching partners:', error);
                // Failed to fetch partners, proceed without selection
                onConfirm(null);
                return;
            }
        }

        // If no partners found, proceed without selection
        if (!partnersList || partnersList.length === 0) {
            onConfirm(null);
            return;
        }

        // Show partner selection dialog
        const result = await Swal.fire({
            title: t('SelectPartner'),
            html: `
                <select id="partner-select" style="width: 100%; padding: 10px; font-size: 14px; border: 1px solid #ddd; border-radius: 4px; box-sizing: border-box; max-width: 100%; margin: 10px 0;">
                    ${partnersList.map((p, index) => `<option value="${p.id}" ${index === 0 ? 'selected' : ''}>${p.name} (${p.equity}%)</option>`).join('')}
                </select>
            `,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: t('Download'),
            cancelButtonText: t('Cancel'),
            width: '380px',
            padding: '1.5em 1.5em 1em',
            customClass: {
                container: 'swal2-container-no-scroll',
                popup: 'swal2-popup-compact'
            },
            didOpen: () => {
                // Prevent horizontal scrolling
                const container = document.querySelector('.swal2-container-no-scroll');
                if (container) {
                    container.style.overflowX = 'hidden';
                    container.style.maxWidth = '100vw';
                }
                const popup = document.querySelector('.swal2-popup-compact');
                if (popup) {
                    popup.style.maxWidth = '380px';
                    popup.style.overflowX = 'hidden';
                }
                const htmlContainer = document.querySelector('.swal2-html-container');
                if (htmlContainer) {
                    htmlContainer.style.overflowX = 'hidden';
                    htmlContainer.style.maxWidth = '100%';
                }
                
                // Ensure select has a value selected
                const select = document.getElementById('partner-select');
                if (select && !select.value && partnersList.length > 0) {
                    select.value = partnersList[0].id;
                }
            },
            preConfirm: () => {
                const select = document.getElementById('partner-select');
                if (!select) {
                    Swal.showValidationMessage(t('PleaseSelectPartner'));
                    return false;
                }
                const partnerId = select.value;
                if (!partnerId || partnerId === '') {
                    Swal.showValidationMessage(t('PleaseSelectPartner'));
                    return false;
                }
                return partnerId;
            },
            allowOutsideClick: false,
            allowEscapeKey: true
        });

        // Check if user confirmed and got a value
        if (result.isConfirmed) {
            let selectedPartnerId = result.value;
            // Fallback: if result.value is not available, get it directly from the select element
            if (!selectedPartnerId) {
                const select = document.getElementById('partner-select');
                if (select && select.value) {
                    selectedPartnerId = select.value;
                }
            }
            if (selectedPartnerId) {
                onConfirm(selectedPartnerId);
            } else {
                Swal.fire({
                    icon: 'error',
                    title: t('Error'),
                    text: t('PleaseSelectPartner')
                });
            }
        }
    };

    const reportsItemsRaw = useMemo(() => {
        const authoritySubItems = isFromHamburgerMenu ? [
            { menuKey: MENU_ITEMS.AdvancesReport, label: t('AdvancesReport'), icon: advancesReportIcon, onClick: () => handleAdvanceReportWithPartnerSelection((partnerId) => { if (partnerId) sessionStorage.setItem('selectedPartnerIdForReport', partnerId); else sessionStorage.removeItem('selectedPartnerIdForReport'); openDateModal('WithholdingTax'); }) },
            { menuKey: MENU_ITEMS.PCNFile, label: t('PCNFile'), icon: pcnFileIcon, onClick: () => openDateModal('PCN') },
            { menuKey: MENU_ITEMS.VATReport, label: t('VATReport'), icon: vatReportIcon, onClick: () => openDateModal('VAT') },
            { menuKey: MENU_ITEMS.WithholdingTaxReports, label: t('WithholdingTaxReports'), icon: vatReportIcon, onClick: () => openWithholdingTaxModel('VAT') },
            { menuKey: MENU_ITEMS.ClientWithholdingTaxReports, label: t('ClientWithholdingTaxReports'), icon: vatReportIcon, onClick: () => openClientWithholdingTaxModel('VAT') },
            { menuKey: MENU_ITEMS.Item856, label: t('856'), icon: vatReportIcon, onClick: () => setShow856Modal(true) },
            { menuKey: MENU_ITEMS.UniformFile, label: t('UniformFile'), icon: vatReportIcon, onClick: () => setShowUniformFileModal(true) },
        ] : [
            { menuKey: MENU_ITEMS.AdvancesReport, label: t('AdvancesReport'), icon: advancesReportIcon, onClick: () => handleAdvanceReportWithPartnerSelection((partnerId) => downloadWithholdingTaxReport(partnerId)) },
            { menuKey: MENU_ITEMS.PCNFile, label: t('PCNFile'), icon: pcnFileIcon, onClick: downloadPCNReport },
            { menuKey: MENU_ITEMS.VATReport, label: t('VATReport'), icon: vatReportIcon, onClick: downloadVATReport },
            { menuKey: MENU_ITEMS.WithholdingTaxReports, label: t('WithholdingTaxReports'), icon: vatReportIcon, onClick: () => openWithholdingTaxModel('VAT') },
            { menuKey: MENU_ITEMS.ClientWithholdingTaxReports, label: t('ClientWithholdingTaxReports'), icon: vatReportIcon, onClick: () => openClientWithholdingTaxModel('VAT') },
            { menuKey: MENU_ITEMS.Item856, label: t('856'), icon: vatReportIcon, onClick: handleClickOpen856 },
            { menuKey: MENU_ITEMS.UniformFile, label: t('UniformFile'), icon: vatReportIcon, onClick: handleClickUnifrom },
        ];

        return [
            { menuKey: MENU_ITEMS.SortCodeReport, label: t('SortCodeReport'), icon: sortCodeReportIcon, onClick: () => viewProfitAndLossDetails("ProfitAndLossReport"), subItems: null },
            { menuKey: MENU_ITEMS.TrialBalance, label: t('TrialBalance'), icon: profitAndLossIcon, onClick: () => viewLedgerReport("TrialBalance"), subItems: null },
            { menuKey: MENU_ITEMS.ReportDetailedProfitAndLoss, label: t('ReportDetailedProfitAndLoss'), icon: accountCardsTableIcon, onClick: () => viewLedgerReport("ReportDetailedProfitAndLoss", true), subItems: null },
            ...(userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium ? [
                { menuKey: MENU_ITEMS.ProfittAndLoss6111, label: t('ProfittAndLoss6111'), icon: profitAndLossIcon, onClick: () => viewProfittAndLoss6111("ProfittAndLoss6111"), subItems: null },
                { menuKey: MENU_ITEMS.Report1214, label: t('Report1214'), icon: profitAndLossIcon, onClick: () => viewReport1214("Report1214"), subItems: null },
                { menuKey: MENU_ITEMS.Report1214B, label: t('Report1214B'), icon: profitAndLossIcon, onClick: () => viewReport1214B("Report1214B"), subItems: null },
                { menuKey: MENU_ITEMS.Report1281, label: t('Report1281'), icon: profitAndLossIcon, onClick: () => viewReport1281("Report1281"), subItems: null },
                { menuKey: MENU_ITEMS.Report1362, label: t('Report1362'), icon: profitAndLossIcon, onClick: () => viewReport1362("Report1362"), subItems: null },
                { menuKey: MENU_ITEMS.AnnualReportQuestionnaire, label: t('AnnualReportQuestionnaire'), icon: profitAndLossIcon, onClick: () => viewAnnualReportQuestionnaire("AnnualReportQuestionnaire"), subItems: null },
            ] : []),
            { menuKey: MENU_ITEMS.AccountCardDashboard, label: t('DebtorsCreditorsLedgerReport'), icon: accountCardsTableIcon, onClick: () => viewAccountCardDashboardBAccountCard(), subItems: null },
            { menuKey: MENU_ITEMS.ReceivablesAging, label: t('ReceivablesAgingByMonths', 'גיול חובות לפי חודשים'), icon: accountCardsTableIcon, onClick: () => viewReceivablesAging && viewReceivablesAging('ReceivablesAging'), subItems: null },
            { menuKey: MENU_ITEMS.CashFlowForecast, label: t('CashFlowForecast', 'דוח תזרים מזומנים'), icon: <CalendarMonthIcon sx={{ color: '#3c51ff', fontSize: 24 }} />, onClick: () => viewCashFlowForecast && viewCashFlowForecast('CashFlowForecast'), subItems: null },
            { menuKey: MENU_ITEMS.ForeignTravelReport, label: t('ForeignTravelReport', 'דו"ח נסיעה לחו"ל'), icon: <FlightTakeoffIcon sx={{ color: '#3c51ff', fontSize: 24 }} />, onClick: () => viewForeignTravelReport && viewForeignTravelReport('ForeignTravelReport'), subItems: null },
            { menuKey: MENU_ITEMS.ClientExpenseAssignmentReport, label: t('ClientExpenseAssignmentReport', 'דוח שיוך הוצאות'), icon: accountCardsTableIcon, onClick: () => viewClientExpenseAssignmentReport && viewClientExpenseAssignmentReport('ClientExpenseAssignmentReport'), subItems: null },
            ...(handleDownloadReceptionLog ? [{ menuKey: MENU_ITEMS.DownloadReceptionLog, label: t('DownloadReceptionLog'), icon: <GetAppIcon sx={{ color: '#3c51ff', fontSize: 24 }} />, onClick: handleDownloadReceptionLog, subItems: null }] : []),
            { menuKey: 'ReportsForAuthority', label: t('ReportsForAuthority'), icon: isFromHamburgerMenu ? reports1Icon : reportsIcon, onClick: () => {}, subItems: authoritySubItems },
        ];
    }, [
        t, client, isFromHamburgerMenu, userTypeContext, permissionsState, Constants, viewProfitAndLossDetails, viewProfittAndLoss6111, viewReport1214, viewReport1214B, viewReport1281, viewReport1362, viewAnnualReportQuestionnaire, viewLedgerReport, viewAccountCardDashboardBAccountCard, viewReceivablesAging, viewCashFlowForecast, viewForeignTravelReport, viewClientExpenseAssignmentReport,
        downloadWithholdingTaxReport, downloadPCNReport, downloadVATReport, openWithholdingTaxModel, openClientWithholdingTaxModel,
        handleClickOpen856, handleClickUnifrom, openDateModal, setShow856Modal, setShowUniformFileModal,
        handleDownloadReceptionLog, sortCodeReportIcon, profitAndLossIcon, accountCardsTableIcon,reports1Icon,
        reportsIcon, advancesReportIcon, pcnFileIcon, vatReportIcon, token, partners
    ]);

    const reportsItems = useMemo(() => filterByRestrictions(reportsItemsRaw, MENU_CATEGORIES.Reports), [reportsItemsRaw, restrictions]);


    const salesItemsRaw = useMemo(() => {
        const isLawyer = client?.businessField === Constants.Lawyer;
        const items = [
            { menuKey: MENU_ITEMS.ReferenceSequence, label: t('ReferenceSequence'), icon: referenceSequenceIcon, onClick: openReferenceSequenceModal, subItems: null },
            { menuKey: MENU_ITEMS.DocumentItems, label: t('DocumentItems'), icon: InvoiceItemsIcon, onClick: () => viewClientItems("DocumentItems"), subItems: null },
            { menuKey: MENU_ITEMS.InventoryManagement, label: t('InventoryManagement'), icon: () => <Inventory2Icon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewInventoryItems("InventoryManagement"), subItems: null },
            { menuKey: MENU_ITEMS.DeliveryNote, label: t('DeliveryNote'), icon: () => <LocalShippingIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewInventoryItems("InventoryManagement"), subItems: null },
            { menuKey: MENU_ITEMS.ReturnNote, label: t('ReturnNote'), icon: () => <AssignmentReturnIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewInventoryItems("InventoryManagement"), subItems: null },
            { menuKey: MENU_ITEMS.TransactionDocuments, label: t('TransactionDocuments'), icon: transactionDocumentsIcon, onClick: () => viewTransactionDocuments("TransactionDocuments"), subItems: null },
            { menuKey: MENU_ITEMS.CancelDocuments, label: t('CancelDocuments'), icon: () => <CancelIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewTransactionDocuments("TransactionDocuments", true), subItems: null },
            ...(viewReceivables ? [{ label: t('Receivables', 'Accounts Receivable'), icon: accountCardsTableIcon, onClick: () => viewReceivables("Receivables"), subItems: null }] : []),
        ];
        if (isLawyer) {
            items.push(
                { menuKey: MENU_ITEMS.LawyerInvoice, label: t('LawyerInvoice'), icon: () => <DescriptionIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateLawyerInvoice", 'LawyerInvoice'), subItems: null },
                { menuKey: MENU_ITEMS.LawyerReceipt, label: t('LawyerReceipt'), icon: () => <ReceiptIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateLawyerInvoice", 'LawyerReceipt'), subItems: null }
            );
        } else {
            items.push(
                { menuKey: MENU_ITEMS.TaxInvoice, label: t('TaxInvoice'), icon: () => <DescriptionIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateInvoice", 'TaxInvoice'), subItems: null },
                { menuKey: MENU_ITEMS.ReceiptTax, label: t('ReceiptTax'), icon: () => <ReceiptIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate('/ReceiptTax', 'ReceiptTax'), subItems: null }
            );
        }
        items.push(
            { menuKey: MENU_ITEMS.FixedPurchaseSale, label: t('FixedPurchaseSale'), icon: () => <DescriptionIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate('/CreateFixedPurchaseSale', 'FixedPurchaseSale'), subItems: null },
            { menuKey: MENU_ITEMS.FixedPurchaseSaleReceipt, label: t('FixedPurchaseSaleReceipt'), icon: () => <ReceiptIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate('/CreateFixedPurchaseSale', 'FixedPurchaseSaleReceipt'), subItems: null },
            { menuKey: MENU_ITEMS.CreditNote, label: t('CreditNote'), icon: () => <NoteIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateInvoice", 'CreditNote'), subItems: null },
            { menuKey: MENU_ITEMS.Receipt, label: t('Receipt'), icon: () => <ReceiptIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate('/ReceiptTax', 'Receipt'), subItems: null },
            { menuKey: MENU_ITEMS.Transaction, label: t('Transaction'), icon: transactionDocumentsIcon, onClick: () => viewDocumentCreate("/CreateInvoice", 'Transaction'), subItems: null },
            { menuKey: MENU_ITEMS.Quotation, label: t('Quotation'), icon: () => <DescriptionIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateInvoice", 'Quotation'), subItems: null },
            { menuKey: MENU_ITEMS.Order, label: t('Order'), icon: () => <ShoppingCartIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateInvoice", 'Order'), subItems: null },
            { menuKey: MENU_ITEMS.SelfInvoice, label: t('SelfInvoice'), icon: () => <ReceiptIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewDocumentCreate("/CreateSelfInvoice", 'SelfInvoice'), subItems: null }
        );
        return items;
    }, [t, client, viewClientItems, viewTransactionDocuments, viewDocumentCreate, referenceSequenceIcon, viewInventoryItems, InvoiceItemsIcon, transactionDocumentsIcon, Constants.Lawyer, viewReceivables, accountCardsTableIcon]);

    const salesItems = useMemo(() => filterByRestrictions(salesItemsRaw, MENU_CATEGORIES.Sales), [salesItemsRaw, restrictions]);

    const vehicleItemsRaw = useMemo(() => [
        { menuKey: MENU_ITEMS.VehicleManagement, label: t('VehicleManagement'), icon: InvoiceItemsIcon, onClick: () => viewVehicleManagement("VehicleManagement"), subItems: null },
    ], [t, viewVehicleManagement, InvoiceItemsIcon]);

    const vehicleItems = useMemo(() => filterByRestrictions(vehicleItemsRaw, MENU_CATEGORIES.Vehicles), [vehicleItemsRaw, restrictions]);

    const garageItemsRaw = useMemo(() => [
        { menuKey: MENU_ITEMS.GarageWorkDiary, label: t('GarageWorkDiary'), icon: InvoiceItemsIcon, onClick: () => viewGarageWorkDiary("GarageWorkDiary"), subItems: null },
    ], [t, viewGarageWorkDiary, InvoiceItemsIcon]);

    const garageItems = useMemo(() => filterByRestrictions(garageItemsRaw, MENU_CATEGORIES.Garage), [garageItemsRaw, restrictions]);

    const auditItemsRaw = useMemo(() => [
        { menuKey: MENU_ITEMS.Audit, label: t('Audit'), icon: auditIcon, onClick: () => viewAudit("Audit"), subItems: null },
    ], [t, viewAudit, auditIcon]);

    const auditItems = useMemo(() => filterByRestrictions(auditItemsRaw, MENU_CATEGORIES.Audit), [auditItemsRaw, restrictions]);

    const bankItemsRaw = useMemo(() => [
        { menuKey: MENU_ITEMS.BankMatching, label: t('BankMatching'), icon: bankIcon, onClick: () => viewBankTransactions("BankMatching"), subItems: null },
        { menuKey: MENU_ITEMS.CardMatching, label: t('CardMatching'), icon: cardMatchingIcon, onClick: () => viewCardMatching("CardMatching"), subItems: null },
        { menuKey: MENU_ITEMS.BankPages, label: t('BankPages'), icon: bankPageIcon, onClick: () => viewBankPage("BankPages"), subItems: null },
    ], [t, viewBankTransactions, viewCardMatching, viewBankPage, bankIcon, cardMatchingIcon, bankPageIcon]);

    const bankItems = useMemo(() => filterByRestrictions(bankItemsRaw, MENU_CATEGORIES.Bank), [bankItemsRaw, restrictions]);

    const documentsItemsRaw = useMemo(() => {
        const otherDocumentsCount = Array.isArray(parsedOtherDocuments) ? parsedOtherDocuments.reduce((sum, item) => sum + (item.number || 0), 0) : 0;
        const permanentFilesCount = Array.isArray(parsedPermanentFiles) ? parsedPermanentFiles.reduce((sum, item) => sum + (item.number || 0), 0) : 0;
        const customTitleItems = (Array.isArray(parsedCustomTitles) ? parsedCustomTitles : []).map((entry) => ({
            menuKey: entry.label === PERMANENT_FILE_TITLE_NAME ? MENU_ITEMS.PermanentFile : MENU_ITEMS.OtherDocuments,
            label: entry.label,
            icon: () => <FolderSpecialIcon sx={{ color: '#304FFF', fontSize: 24 }} />,
            onClick: entry.onClick,
            count: hideStatusBadge ? undefined : (entry.subItems || []).reduce((sum, item) => sum + (item.number || 0), 0),
            subItems: entry.subItems,
        }));
        return [
            { menuKey: MENU_ITEMS.OtherDocuments, label: t('OtherDocuments'), icon: otherDocumentIcon, onClick: () => viewOtherDocumentDetails("OtherDocuments", null, false), count: hideStatusBadge ? undefined : otherDocumentsCount, subItems: parsedOtherDocuments },
            // The built-in entry only lists types without a title; once they move to the seeded "תיק קבע" title it is empty.
            ...(Array.isArray(parsedPermanentFiles) && parsedPermanentFiles.length > 0
                ? [{ menuKey: MENU_ITEMS.PermanentFile, label: t('PermanentFile'), icon: () => <FolderSpecialIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewOtherDocumentDetails("OtherDocuments", null, true), count: hideStatusBadge ? undefined : permanentFilesCount, subItems: parsedPermanentFiles }]
                : []),
            ...customTitleItems,
            { menuKey: MENU_ITEMS.SignatureDocuments, label: t('SignatureDocuments'), icon: () => <DrawIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewSignatureDocument("SignatureDocuments"), subItems: null },
            ...(userTypeContext?.toString() !== Constants.UserType.Client ? [{ menuKey: MENU_ITEMS.Forms, label: t('Forms'), icon: () => <DescriptionIcon sx={{ color: '#304FFF', fontSize: 24 }} />, onClick: () => viewForms("Forms"), subItems: null }] : []),
        ];
    }, [t, client, viewOtherDocumentDetails, viewSignatureDocument, viewForms, parsedOtherDocuments, parsedPermanentFiles, parsedCustomTitles, otherDocumentIcon, hideStatusBadge, userTypeContext, Constants]);

    const documentsItems = useMemo(() => filterByRestrictions(documentsItemsRaw, MENU_CATEGORIES.Documents), [documentsItemsRaw, restrictions]);

    return {
        accountingItems,
        reportsItems,
        salesItems,
        vehicleItems,
        garageItems,
        auditItems,
        bankItems,
        documentsItems,
        settingsItems,
    };
}
